module.exports = __webpack_public_path__ + "static/media/ramadaphuket.d8db0617.png";